module.exports = __webpack_public_path__ + "static/media/4.887e60b6.png";